import { ProgressCallback } from "../types/ProgressTypes";
import { doesSheetExist, handleExistingSheetInsertionData, handleNewSheetInsertionData } from "../wrappers/common";
import { EupType } from "@carbowaste/excel-sheets-generator/dist/types/models";
import * as kpoConfirmed from "@carbowaste/excel-sheets-generator/dist/sheets/kpo/kpo_confirmed";
import * as kpoStatusOverview from "@carbowaste/excel-sheets-generator/dist/sheets/kpo/kpo_status_overview";
import * as kpoCardPrint from "@carbowaste/excel-sheets-generator/dist/sheets/kpo/kpo_card_print";

export class KPODataFetchWrapper {

    static wrapKpoConfirmedDataFetch(
        eupType: EupType,
        dateFrom: Date,
        dateTo: Date,
        sheetName: string,
    ) {
        return async (callbacks: ProgressCallback) => {
            try {
                callbacks.onProgress?.("Inicjalizowanie pobierania danych KPO...", 0);

                callbacks.onProgress?.("Pobieranie danych...", 20);
                const matrix = await kpoConfirmed.getKpoMatrix(eupType, dateFrom, dateTo);

                callbacks.onProgress?.("Sprawdzanie istniejącego arkusza...", 40);
                const sheetExists = await doesSheetExist(sheetName);
                if (sheetExists) {
                    callbacks.onProgress?.("Arkusz już istnieje, aktualizacja danych...", 60);
                    await handleExistingSheetInsertionData(sheetName);
                    // Nagłówek arkusza
                    await kpoConfirmed.firstEightRowsHeader(sheetName, eupType, dateFrom, dateTo);
                } else {
                    callbacks.onProgress?.("Tworzenie nowego arkusza...", 60);
                    await handleNewSheetInsertionData(sheetName);
                    // Nagłówek arkusza
                    await kpoConfirmed.firstEightRowsHeader(sheetName, eupType, dateFrom, dateTo);
                }

                if (matrix && matrix.length > 1) {
                    // Nagłówki wierszy
                    await kpoConfirmed.addMatrixHeaders(sheetName);
                    callbacks.onProgress?.("Zapisywanie danych do arkusza...", 80);
                    // Wstawianie wartości do arkusza
                    await kpoConfirmed.insertMatrixData(sheetName, matrix, eupType);
                    callbacks.onProgress?.("Finalizowanie...", 100);
                    callbacks.onSuccess?.("Raport KPO wygenerowany pomyślnie!");
                } else {
                    // Naagłówki wierszy
                    await kpoConfirmed.addMatrixHeaders(sheetName);
                    // Wstawianie wiersza z informacją o braku danych
                    await kpoConfirmed.insertNoDataMessage(sheetName, eupType);
                    callbacks.onProgress?.("Finalizowanie...", 100);
                    callbacks.onError?.("Brak danych do wygenerowania raportu KPO");
                    //throw new Error("Brak danych do wygenerowania raportu KPO");
                }

            } catch (error) {
                callbacks.onError?.(error instanceof Error ? error.message : "Wystąpił błąd podczas generowania raportu KPO");
            }
        };
    }

    static wrapKpoStatusOverviewDataFetch(
        eupType: EupType,
        Year: number,
        sheetName: string,
    ) {
        return async (callbacks: ProgressCallback) => {
            try {
                callbacks.onProgress?.("Inicjalizowanie pobierania danych KPO...", 0);

                callbacks.onProgress?.("Pobieranie danych...", 20);
                const matrix = await kpoStatusOverview.getKpoMatrix(eupType, Year);

                callbacks.onProgress?.("Sprawdzanie istniejącego arkusza...", 40);
                const sheetExists = await doesSheetExist(sheetName);
                if (sheetExists) {
                    callbacks.onProgress?.("Arkusz już istnieje, aktualizacja danych...", 60);
                    await handleExistingSheetInsertionData(sheetName);
                    // Nagłówek arkusza
                    await kpoStatusOverview.firstEightRowsHeader(sheetName, eupType, Year);
                } else {
                    callbacks.onProgress?.("Tworzenie nowego arkusza...", 60);
                    await handleNewSheetInsertionData(sheetName);
                    // Nagłówek arkusza
                    await kpoStatusOverview.firstEightRowsHeader(sheetName, eupType, Year);
                }

                if (matrix && matrix.length > 1) {
                    // Naagłówki wierszy
                    await kpoStatusOverview.addMatrixHeaders(sheetName);
                    callbacks.onProgress?.("Zapisywanie danych do arkusza...", 80);
                    // Wstawianie wartości do arkusza
                    await kpoStatusOverview.insertMatrixData(sheetName, matrix, eupType);
                    callbacks.onProgress?.("Finalizowanie...", 100);
                    callbacks.onSuccess?.("Raport KPO wygenerowany pomyślnie!");
                } else {
                    // Naagłówki wierszy
                    await kpoStatusOverview.addMatrixHeaders(sheetName);
                    // Wstawianie wiersza z informacją o braku danych
                    await kpoStatusOverview.insertNoDataMessage(sheetName, eupType);
                    callbacks.onProgress?.("Finalizowanie...", 100);
                    callbacks.onError?.("Brak danych do wygenerowania raportu KPO");
                    //throw new Error("Brak danych do wygenerowania raportu KPO");
                }

            } catch (error) {
                callbacks.onError?.(error instanceof Error ? error.message : "Wystąpił błąd podczas generowania raportu KPO");
            }
        };
    }

    static wrapKpoCardPrintDataFetch(
        eupType: EupType,
        kpoCardNumber: string,
        sheetName: string,
    ) {
        return async (callbacks: ProgressCallback) => {
            try {
                callbacks.onProgress?.("Inicjalizowanie pobierania danych KPO...", 0);

                callbacks.onProgress?.("Pobieranie danych...", 20);
                const result = await kpoCardPrint.getKpoPrintData(eupType, kpoCardNumber);

                callbacks.onProgress?.("Sprawdzanie istniejącego arkusza...", 40);
                const sheetExists = await doesSheetExist(sheetName);
                if (sheetExists) {
                    callbacks.onProgress?.("Arkusz już istnieje, aktualizacja danych...", 60);
                    await handleExistingSheetInsertionData(sheetName);
                } else {
                    callbacks.onProgress?.("Tworzenie nowego arkusza...", 60);
                    await handleNewSheetInsertionData(sheetName);
                }

                // Wstawianie wartości do arkusza
                await kpoCardPrint.kpoCardPrintSheet(sheetName, eupType);
                await kpoCardPrint.insertKpoPrintData(sheetName, result.printData);

                callbacks.onProgress?.("Finalizowanie...", 100);
                // Przekaż metadata przez onSuccess
                console.log('📤 KPODataFetchWrapper: Calling onSuccess with metadata:', result.metadata);
                callbacks.onSuccess?.("Raport karty KPO wygenerowany pomyślnie!", result.metadata);

            } catch (error) {
                callbacks.onError?.(error instanceof Error ? error.message : "Wystąpił błąd podczas pobierania danych karty KPO");
            }
        };
    }

}